import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/portfolio/compliance-scanner/page.tsx");
